import { NgModule, DEFAULT_CURRENCY_CODE, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutsModule} from "./layouts/layouts.module";
import { PagesModule } from "./pages/pages.module";

// Auth
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS  } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';

// Language
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { ToastrModule } from 'ngx-toastr';
import { ToasterNotificationService } from './core/services/toaster-notification.service';
import { NgbdListSortableHeaderDirective } from './core/directives/ngbd-list-sortable-header.directive';
import { I18nModule } from './core/i18n/i18n.module';
import { LastActiveService } from './core/services/last-active.service';
import { UserSessionTrackerService } from './core/services/user-session-tracker.service';


import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import { MsalGuardConfiguration, MsalModule } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';


export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
  };
}


// const fbLoginOptions = {
//   scope: 'pages_messaging,pages_messaging_subscriptions,email,pages_show_list,manage_pages',
//   return_scopes: true,
//   enable_profile_selector: true
// }; // https://developers.facebook.com/docs/reference/javascript/FB.login/v2.11

// const googleLoginOptions = {
//   scope: 'profile email'
// }; // https://developers.google.com/api-client-library/javascript/reference/referencedocs#gapiauth2clientconfig

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

const msalConfig = environment.msalAzureConfig;

@NgModule({
  declarations: [ //Declarations are for Components, Directives & Pipes
    AppComponent, NgbdListSortableHeaderDirective
  ],
  imports: [ //import any required feature or functionality
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    PagesModule,
    ToastrModule.forRoot(),   
    BrowserModule,

    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: msalConfig.clientId,
          authority: msalConfig.authority,
          redirectUri: msalConfig.redirectUri
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: isIE,
        },
      }),
      {
        interactionType: InteractionType.Redirect, // Msal Guard Configuration
        authRequest: {
          scopes: ["user.read"],
        },
      },
      {
        interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
        protectedResourceMap: new Map([
          ["https://graph.microsoft.com/v1.0/me", ["user.read"]]
        ]),
      }
    ),
   ],
  providers: [ //  //The Services to add to the global collection of services. The services are then available for injection via DI
    ToasterNotificationService,  
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: JwtInterceptor, 
      multi: true 
    },            
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: ErrorInterceptor, 
      multi: true 
    },    
    I18nModule.setLocale(),     
    I18nModule.setLocaleId(),    
    {
      provide: DEFAULT_CURRENCY_CODE, 
      useValue: '$'
    },
    {
      provide: APP_INITIALIZER, //DI Token
      multi: true,
      deps: [LastActiveService],
      useFactory: (lastActiveService: LastActiveService) => () =>
        lastActiveService.run(),
    },
    {
      provide: APP_INITIALIZER, //DI Token   
      multi: true, 
      deps: [UserSessionTrackerService],
      useFactory: (userSessionTrackerService: UserSessionTrackerService) => () => userSessionTrackerService,      
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.recaptchaKey } as RecaptchaSettings,
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: MsalInterceptor,
    //   multi: true,
    // },
    // MsalGuard
    //  {
    //   provide: 'SocialAuthServiceConfig',
    //   useValue: {
    //     autoLogin: false,
    //     lang: 'en',
    //     providers: [
    //       {
    //         id: GoogleLoginProvider.PROVIDER_ID,
    //         provider: new GoogleLoginProvider(
    //           'clientId'
    //         )
    //       },
    //       {
    //         id: FacebookLoginProvider.PROVIDER_ID,
    //         provider: new FacebookLoginProvider('clientId')
    //       }
    //     ],
    //     onError: (err) => {
    //       console.error(err);
    //     }
    //   } as SocialAuthServiceConfig,
    // }
   
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
